import { cn } from '@poseidon/components/cn';
import { General, Time } from '@poseidon/components/StrokeIcons';

import type { SequenceStepMedallion } from '~/components/Sequence/sequenceStepStatus';

interface Props {
  medallion: SequenceStepMedallion;
  /** The ring colour must match whatever the badge sits on, so it reads as a cut-out (canvas vs card). */
  className?: string;
}

/**
 * The corner badge on a settled step's icon tile. A step that ran gets a badge rather than a fade — "done"
 * should read as something that happened, not as something switched off — and the badge says HOW it landed:
 * a connection made, an invitation still hanging, or one we took back.
 */
export function SequenceMedallionBadge({ medallion, className }: Props) {
  return (
    <span
      className={cn(
        'absolute -bottom-1 -right-1 flex size-3.5 items-center justify-center rounded-full text-white ring-2 ring-slate-50 dark:ring-neutral-900 [&>svg]:size-2.5',
        medallion === 'check' && 'bg-mantis-500',
        medallion === 'pending' && 'bg-amber-400',
        medallion === 'withdrawn' && 'bg-lynch-400',
        className,
      )}>
      {medallion === 'check' && <General.Check />}
      {medallion === 'pending' && <Time.Clock />}
      {medallion === 'withdrawn' && <General.XMark />}
    </span>
  );
}
